import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@wff/store";
import { useAppDispatch } from "@wff/store/hooks";
import { getBottomLineRatingAction } from "@wff/store/yotpoSlice";

const useSelectBottomLineRating = (productId: string) => {
  return useSelector(
    (state: RootState) => state.yotpo?.bottomLineRatingResult?.[productId]
  );
};

export const useBottomLineRating = (productId: string) => {
  const currentBottomLineRating = useSelectBottomLineRating(productId);
  const dispatch = useAppDispatch();
  const mountRef = useRef(false); // seems like JM intended for the below useEffect to only execute on Mount, so I'm adding that code intention specifically

  useEffect(() => {
    if (!mountRef.current && productId) {
      mountRef.current = true;
      dispatch(getBottomLineRatingAction(productId));
    }
    return () => {
      mountRef.current = false;
    };
  }, [productId, dispatch]);

  return currentBottomLineRating;
};
